import type { Client } from "#/types/client";
import { createContext } from "react";

interface ClientContextType {
  client: Client | null;
  setClient: (client: Client) => void;
}

export const ClientContext = createContext<ClientContextType | null>(null);
